import React from 'react';

import { getExternalUrlForSkadekategori } from '../../deep-link-handler';
import { Skadekategori } from '../../deep-link-handler/skadekategori';
import { eikaForsikringPhonenumber, LinkButton, phone } from '../utils';

export default (
    <div>
        <p>Her kan du melde skade innen personforsikring som dekker:</p>
        <ul>
            <li>Uførhet</li>
            <li>Kritisk sykdom</li>
            <li>Dødsfall</li>
        </ul>
        <p>Ønsker du veiledning kan du kontakte oss på telefon: {phone(eikaForsikringPhonenumber)}</p>
        <LinkButton href={getExternalUrlForSkadekategori(Skadekategori.DegOgDineUforhetDodsfallEllerKritiskSykdom)}>
            Meld skade
        </LinkButton>
    </div>
);
